<template>
  <v-app>
    <vue-confirm-dialog></vue-confirm-dialog>
    <router-view></router-view>
    <snackbar />
  </v-app>
</template>

<script>
import Snackbar from "./components/General/Snackbar.vue";
import { inactivityMixin } from './inactivityMixin'

export default {
  mixins: [inactivityMixin],

  components: {
    Snackbar,
  },

  data() {
    return {
      inactivityTimeout: 10 * 60 * 1000 // 10 minutos para este componente
    }
  }
};
</script>
